import { memoize } from "@ls/js-utils";
import { createSelector } from "reselect";
import { selectAttributeData } from "state/attributes/selectors";
import SelectionState from "state/selections/SelectionState";
import { selectAsOfDateValue } from "state/selections/selector";
import scope from "./scope";

export const selectEnableAsOfDate = memoize(
  (selectionState) => (state) => state[scope][selectionState].enableAsOfDate
);

export const selectRowsMap = createSelector(
  selectEnableAsOfDate(SelectionState.COMMITTED),
  selectAsOfDateValue(SelectionState.COMMITTED),
  selectAttributeData,
  (enableAsOfDate, asOfDateValue, groupingResponse) => {
    if (!enableAsOfDate || !groupingResponse?.attributes) {
      return {};
    }
    return groupingResponse.attributes.reduce((rowsMap, attributes) => {
      const { primaryKey = {} } = attributes;
      const { entityId } = primaryKey;
      rowsMap[entityId] = {
        "misc-asOfDate": asOfDateValue,
      };
      return rowsMap;
    }, {});
  }
);
